import { render, staticRenderFns } from "./PartnerRegistrationForm.vue?vue&type=template&id=518fd79a"
import script from "./PartnerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PartnerRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormRadio: require('/builds/docue/website/components/Form/FormRadio.vue').default,FormInput: require('/builds/docue/website/components/Form/FormInput.vue').default,FormCompanyInput: require('/builds/docue/website/components/Form/FormCompanyInput.vue').default,FormCheckbox: require('/builds/docue/website/components/Form/FormCheckbox.vue').default,IconLoader: require('/builds/docue/website/components/Icon/IconLoader.vue').default,FormButton: require('/builds/docue/website/components/Form/FormButton.vue').default,AcceptTerms: require('/builds/docue/website/components/AcceptTerms.vue').default,OutlineExclamationIcon: require('/builds/docue/website/node_modules/@nuxt-hero-icons/outline/src/components/ExclamationIcon.vue').default})
